import React, { useState } from "react";
import { useMediaQuery } from 'react-responsive'; // Import useMediaQuery hook
import "./spectacles.css";

function Spectacles() {
  const initialCategories = {
    MEN: [
      { id: 1, image: "/frame/frame.jpg", name: "Aspinal of London ASPM512", price: 110000},
      { id: 2, image: "/frame/Calvin KLEIN jeans CKJ19531A0515418145.jpg", name: "Calvin KLEIN jeans CKJ19531A0515418145", price: 54000},
      { id: 3, image: "/frame/7A5678CQ140.jpg", name: "Seven Street 7A5678CQ140", price: 35000},
      { id: 4, image: "/frame/7A561807140.jpg", name: "Seven Street 7A561807140", price: 35000 },
      { id: 5, image: "/frame/560 18-140-PLAFHUM.jpg", name: "BOSS 560 18-140-PLAFHUM", price: 80000},
      { id: 6, image: "/frame/8897PJP140.jpg", name: "Carrera 8897PJP140", price: 45000},
      { id: 7, image: "/Che 627 C34 52-17-140   8550.jpg", name: "Che 627 C34 52-17-140", price: 15000},
      { id: 8, image: "/Che 602 C17 53-17-140   8500.jpg", name: "Che 602 C17 53-17-140", price: 15000},
      { id: 9, image: "/Che 527 C6S 51-15-130   8500.jpg", name: "Che 527 C6S 51-15-130", price: 15000},
      { id: 10, image: "/Che 625 C6M 52-18-140      8500.jpg", name: "Che 625 C6M 52-18-140", price: 15000},

      { id: 31, image: "/Che 624 C6S 53-15-140     8550.jpg", name: "Che 624 C6S 53-15-140", price: 15000},
      { id: 32, image: "/frame/CM9081.jpg", name: "Cocoa Mint CM9081", price: 68000},
      { id: 33, image: "/frame/CM9111.jpg", name: "Cocoa Mint CM9111", price: 68000},
      { id: 34, image: "frame/CO1005.jpg", name: "Steuart CO1005", price: 17000 },
      { id: 35, image: "/Manchester MC2103L 52-18-140 C1   11000.jpg", name: "Manchester MC2103L 52-18-140 C1", price: 15000},
      { id: 36, image: "/Manchester MC2103L 22-18-140 C8   11000.jpg", name: "Manchester MC2103L 22-18-140 C8", price: 15000},
      { id: 37, image: "/Manchester MC8053G 54-17-135 C13  11000.jpg", name: "Manchester MC8053G 54-17-135 C13", price: 15000},
      // { id: 38, image: "/frame/JSB1038M55613145.jpg", name: "Jeep JSB1038M55613145", price: 15000},
      { id: 39, image: "/Manchester MCP8701L 50-15-140 C53   16000.jpg", name: "Manchester MCP8701L 50-15-140 C53", price: 15000},
      { id: 40, image: "/Manchester MCP801 50-16-140 C6M   16000.jpg", name: "Manchester MCP801 50-16-140 C6M", price: 15000},
      { id: 41, image: "/Carrera 4409 003    29700.jpg", name: "Carrera 4409 003", price: 35000},
      { id: 42, image: "/Carrera 1106V 003   29700.jpg", name: "Carrera 1106V 003", price: 35000},

    ],


    WOMEN: [
      { id: 11, image: "/frame/ECIMETOO347.jpg", name: "Lambogini ECIMETOO347", price: 60000 },
      { id: 12, image: "/frame/VL4139.jpg", name: "Lozza VL4139", price: 40000},
      { id: 13, image: "/frame/VL4212.jpg", name: "Lozza VL4212", price: 40000},
      // { id: 14, image: "/Bonia BNI1423 48-23-140 C2  6500.jpg", name: "Bonia BNI1423 48-23-140 C2", price: 6500 },
      { id: 15, image: "/Che 602 C6S 53-17-140    8550.jpg", name: "Che 602 C6S 53-17-140", price: 15000 },
      { id: 16, image: "/Che 630 C7S 50-15-135   8550.jpg", name: "Che 630 C7S 50-15-135", price: 15000 },
      { id: 17, image: "/frame/L2925.jpg", name: "Lacoste L2925", price: 88000 },
      { id: 18, image: "/frame/TB17960.jpg", name: "TimberLand TB17960 ", price: 65000 },
      { id: 19, image: "/frame/S2818RU135.jpg", name: "Seven Street S2818RU135", price: 35000 },
      { id: 20, image: "/Eurospex EXP621 C8 52-15-135    11500.jpg", name: "Eurospex EXP621 C8 52-15-135", price: 25000 },
      
      { id: 21, image: "/frame/VPL927M.jpg", name: "Police VPL927M", price: 60000},
      { id: 22, image: "/frame/VO 5163 W44 530 16 140.jpg", name: "Vogue VO 5163 W44 530 16 140", price: 45000},
      { id: 23, image: "/frame/VO560229425416140.jpg", name: "Vouge VO560229425416140", price: 39000 },
      { id: 24, image: "/frame/ZSF25415135.jpg", name: "Zeiss ZSF25415135", price: 60000 },
      { id: 25, image: "/frame/ZX7045318136.jpg", name: "Gucci ZX7045318136", price: 35000 },
      { id: 26, image: "/frame/S 325 B3V 135.jpg", name: "Seven Street S 325 B3V 135", price: 35000 },
      { id: 27, image: "/frame/S 355 1X2135.jpg", name: "Seven Street S 355 1X2135", price: 35000 },
      { id: 28, image: "/frame/9473025118142.jpg", name: "Enpasso 9473025118142", price: 15000 },
      { id: 29, image: "/frame/9473045117142.jpg", name: "Enpasso 9473045117142", price: 15000 },
      { id: 30, image: "/frame/9473095018142.jpg", name: "Enpasso 9473095018142", price: 15000 },
      { id: 31, image: "/frame/94730251018142.jpg", name: "Enpasso 94730251018142", price: 15000 },
      { id: 32, image: "/frame/EXP633C85.jpg", name: "Enpasso EXP633C85", price: 15000 },
    ],
    KIDS: [

    ],
    // UNISEX: [
    //   { id: 31, image: "/images/unisex1.jpg", name: "Modern Square", price: 5000, brand: "Oakley", size: "Medium" },
    //   { id: 32, image: "/images/unisex2.jpg", name: "Trendy Transparent", price: 5300, brand: "Vogue", size: "Medium" },
    //   { id: 33, image: "/images/unisex1.jpg", name: "Modern Square", price: 5000, brand: "Oakley", size: "Medium" },
    //   { id: 34, image: "/images/unisex2.jpg", name: "Trendy Transparent", price: 5300, brand: "Vogue", size: "Medium" },
    //   { id: 35, image: "/images/unisex1.jpg", name: "Modern Square", price: 5000, brand: "Oakley", size: "Medium" },
    //   { id: 36, image: "/images/unisex2.jpg", name: "Trendy Transparent", price: 5300, brand: "Vogue", size: "Medium" },
    //   { id: 37, image: "/images/unisex1.jpg", name: "Modern Square", price: 5000, brand: "Oakley", size: "Medium" },
    //   { id: 38, image: "/images/unisex2.jpg", name: "Trendy Transparent", price: 5300, brand: "Vogue", size: "Medium" },
    //   { id: 39, image: "/images/unisex1.jpg", name: "Modern Square", price: 5000, brand: "Oakley", size: "Medium" },
    //   { id: 40, image: "/images/unisex2.jpg", name: "Trendy Transparent", price: 5300, brand: "Vogue", size: "Medium" },
    // ],
  };

  const kidsDescription = [
    "Did you know that studies indicate nearly one in five children need spectacles? Kids are naturally curious and eager to explore the world around them—it’s a crucial part of their growth and learning process. However, poor vision can make this journey more difficult! Ensure your child has the clearest vision possible to fuel their curiosity and discoveries. Explore Eye Care Optical and Clinic’s online eyewear store today to find durable and affordable kids’ spectacles that can be customized with prescription lenses—all from the comfort of your home.",
    "Today, children’s spectacles do more than just correct vision—they also serve as stylish accessories! Available in a wide range of colors, sizes, shapes, and materials, these glasses are designed to appeal to young wearers. Gone are the days of teasing; with the trendy designer frames at Eye Care Optical and Clinic, your child will feel confident and receive compliments from their friends. Most importantly, they will love how they look in their new spectacles!",
    "Although parents typically make the final decision on eyewear, it’s essential to involve children in the selection process. Encourage your little one to browse Eye Care Optical and Clinic’s extensive online collection with you and choose a design that suits their personality. Our kids’ spectacles are crafted from high-quality, shatter-proof plastic, making them both safe and durable—ideal for active play and everyday wear.",
    "Shopping for kids' spectacles has never been easier! Visit Eye Care Optical and Clinic’s online store to browse our vast selection of frames and lenses. Use our filtering options to quickly find the perfect pair that fits your budget and meets your child’s needs. Give them the gift of clear vision and confidence today!",
  ];


  const [cart, setCart] = useState(JSON.parse(localStorage.getItem("cart")) || []);
  const [categories, setCategories] = useState(initialCategories);
  const [currentCategory, setCurrentCategory] = useState("MEN");
  const [currentPage, setCurrentPage] = useState(0);
  const [message, setMessage] = useState("");
  const itemsPerPage = 8;





  const handleAddToCart = (product) => {
    const existingProduct = cart.find(item => item.id === product.id);
    if (existingProduct) {
      const updatedCart = cart.map(item =>
        item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
      );
      setCart(updatedCart);
      localStorage.setItem("cart", JSON.stringify(updatedCart));
    } else {
      const newCart = [...cart, { ...product, quantity: 1 }];
      setCart(newCart);
      localStorage.setItem("cart", JSON.stringify(newCart));
    }
    
    // Show alert when product is added
    alert("Product has been added to the cart!");
  };



  
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  const handleNextPage = () => {
    const maxPage = Math.floor(categories[currentCategory].length / itemsPerPage);
    setCurrentPage((prevPage) => Math.min(prevPage + 1, maxPage));
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const currentItems = categories[currentCategory].slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <div className="spectacles-container">
      <h1>Spectacles</h1>
      <div className="category-buttons">
        {Object.keys(categories).map((category) => (
          <button
            key={category}
            className={`category-button ${currentCategory === category ? "active" : ""}`}
            onClick={() => {
              setCurrentCategory(category);
              setCurrentPage(0);
            }}
          >
            {category}
          </button>
        ))}
      </div>




      {currentCategory === "KIDS" && (
        <div className="kids-description">
          <h2>Why Choose Our Kids’ Spectacles?</h2>
          <ul>
            {kidsDescription.map((desc, index) => (
              <li key={index}>{desc}</li>
            ))}
          </ul>
        </div>
      )}








      <div className="items-container">
        {currentItems.map((item) => (
          <div key={item.id} className="item-card">
            <img src={item.image || ""} alt={item.name} className="item-image" />
            <h2 className="item-name">{item.name}</h2>
            <p className="item-price">Rs. {item.price.toLocaleString()}</p>
            <button 
              className="add-to-cart-button" 
              onClick={() => handleAddToCart(item)} // Use the updated handleAddToCart method
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>

      {/* Add mobile-specific layout/behavior */}
      {isMobile ? (
        <div className="mobile-pagination">
          <button 
            className="pagination-button" 
            onClick={handlePrevPage} 
            disabled={currentPage === 0}
          >
            &lt;
          </button>
          <span>Page {currentPage + 1}</span>
          <button
            className="pagination-button"
            onClick={handleNextPage}
            disabled={currentPage === Math.floor(categories[currentCategory].length / itemsPerPage)}
          >
            &gt;
          </button>
        </div>
      ) : (
        <div className="pagination">
          <button
            className="pagination-button"
            onClick={handlePrevPage}
            disabled={currentPage === 0}
          >
            &lt;
          </button>
          <span>
            Page {currentPage + 1} of{" "}
            {Math.ceil(categories[currentCategory].length / itemsPerPage)}
          </span>
          <button
            className="pagination-button"
            onClick={handleNextPage}
            disabled={currentPage === Math.floor(categories[currentCategory].length / itemsPerPage)}
          >
            &gt;
          </button>
        </div>
      )}
      
      {message && <div className="add-to-cart-message">{message}</div>}
    </div>
  );
}

export default Spectacles;
